import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { CATEGORY_ORDER, SUBCATEGORIES } from "../../data/catalog";
import useBrowseState from "../../hooks/useBrowseState";
import { shopPath } from "../../routes";

export default function DepartmentFilter() {
  const { department, latest } = useBrowseState();
  const [expanded, setExpanded] = useState(null);
  const navigationRef = useRef(null);
  const isMobile = () => window.matchMedia?.("(max-width: 720px)").matches;
  useEffect(() => {
    const outside = (event) => { if (!navigationRef.current?.contains(event.target)) setExpanded(null); };
    document.addEventListener("pointerdown", outside);
    return () => document.removeEventListener("pointerdown", outside);
  }, []);
  const categories = SUBCATEGORIES[expanded] || [];


  return (
    <div className="departmentNavigation" ref={navigationRef} onMouseLeave={() => { if (!isMobile()) setExpanded(null); }}
      onBlur={(e) => { if (!e.currentTarget.contains(e.relatedTarget)) setExpanded(null); }}
      onKeyDown={(e) => { if (e.key === "Escape") { setExpanded(null); e.stopPropagation(); } }}>
      <nav className="cats" id="cats" aria-label="Departments">
        {CATEGORY_ORDER.map((c) => (
          <Link to={shopPath({ department: c })} key={c}
            className={`cat ${!latest && c === department ? "active" : ""}`}
            aria-expanded={SUBCATEGORIES[c] ? expanded === c : undefined}
            aria-controls={SUBCATEGORIES[c] ? "departmentCategories" : undefined}
            onMouseEnter={() => { if (!isMobile()) setExpanded(SUBCATEGORIES[c] ? c : null); }}
            onFocus={() => { if (!isMobile()) setExpanded(SUBCATEGORIES[c] ? c : null); }}
            onClick={(event) => {
              if (isMobile() && SUBCATEGORIES[c]) {
                event.preventDefault();
                setExpanded(current => current === c ? null : c);
              } else setExpanded(null);
            }}>
            {c}
          </Link>
        ))}
      </nav>
      {expanded && categories.length > 0 && (
        <div className="departmentDropdown" id="departmentCategories">
          <div className="departmentDropdownLabel">Categories</div>
          <nav className="departmentCategoryLinks" aria-label={`${expanded} categories`}>
            <Link to={shopPath({ department: expanded })} onClick={() => setExpanded(null)}>All {expanded}</Link>
            {categories.map((category) => (
              <Link key={category} to={shopPath({ department: expanded, subcategory: category })} onClick={() => setExpanded(null)}>
                {category === "Kid" ? "Kids" : category}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </div>
  );
}
